module.exports = __webpack_public_path__ + "media/images/upgrade_icon-66c3a19d378e8e542f36f191cb5d9855.png";